import {IUrlConfig} from 'entities/metadata';
import {TCFTDataDto} from 'features/provide-microservice-cft/model/types';
import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';

interface ISendRequestCFTActionArgs {
    referenceUrl?: string;
    requestType?: ERequestType;
    data?: TCFTDataDto;
    token?: string | null;
    urlConfig?: IUrlConfig;
}

export const sendRequestCFTAction = ({
    referenceUrl,
    requestType,
    data,
    token,
    urlConfig,
} : ISendRequestCFTActionArgs) => (
    performRequest({
        url: referenceUrl,
        method: requestType ?? ERequestType.POST,
        headers: ({
            Authorization: token,
            'Referrer-Policy': 'no-referrer',
        }),
        data,
        urlConfig,
    }));
